import { AdminQuickActionsCard } from "@/components/admin/dashboard/AdminQuickActionsCard";
import { AdminStatsGrid } from "@/components/admin/dashboard/AdminStatsGrid";
import { AdminSystemOverviewCard } from "@/components/admin/dashboard/AdminSystemOverviewCard";
import { Skeleton } from "@/components/ui/skeleton";
import type {
  DashboardCompaniesStats,
  DashboardLocationsStats,
  DashboardMaterialsStats,
  DashboardMenusStats,
  DashboardOrganizationsStats,
  DashboardRecipesStats,
  DashboardUsersStats,
} from "@/types/company";

export interface BusinessWidgetData {
  isInternalDashboard: boolean;
  organizationsStats?: DashboardOrganizationsStats;
  companiesStats?: DashboardCompaniesStats;
  locationsStats?: DashboardLocationsStats;
  usersStats?: DashboardUsersStats;
  materialsStats?: DashboardMaterialsStats;
  recipesStats?: DashboardRecipesStats;
  menusStats?: DashboardMenusStats;
  statsLoading: boolean;
}

export function BusinessStatsWidget({ data }: { data: BusinessWidgetData }) {
  return (
    <AdminStatsGrid
      isSuperAdmin={data.isInternalDashboard}
      statsLoading={data.statsLoading}
      organizationsStats={data.organizationsStats}
      companiesStats={data.companiesStats}
      locationsStats={data.locationsStats}
      usersStats={data.usersStats}
      materialsStats={data.materialsStats}
      recipesStats={data.recipesStats}
      menusStats={data.menusStats}
    />
  );
}

export function BusinessQuickActionsWidget({ data }: { data: BusinessWidgetData }) {
  return <AdminQuickActionsCard isSuperAdmin={data.isInternalDashboard} />;
}

export function BusinessSystemOverviewWidget({ data }: { data: BusinessWidgetData }) {
  void data;
  return <AdminSystemOverviewCard />;
}

export function BusinessDashboardSkeleton() {
  return (
    <div className="space-y-6 p-3">
      <div>
        <Skeleton className="h-8 w-56" />
        <Skeleton className="mt-2 h-4 w-72" />
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="h-28 w-full rounded-lg" />
        ))}
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {Array.from({ length: 2 }).map((_, index) => (
          <Skeleton key={index} className="h-64 w-full rounded-lg" />
        ))}
      </div>
    </div>
  );
}
